import Angular from "angular";
import Template from "./booking-details.html";
import Controller from "./booking-details.controller";
import Bookings from "../../services/bookings.service";
import Vehicles from "../../services/vehicles.service";
import VehicleCheckIcon from '../../components/vehiclecheck-state-icon/vehiclecheck-state-icon';
import WheelStorageActiveIcon from "../../components/wheel-storage-active-icon/wheel-storage-active-icon";
import WheelStorageStateIcon from "../../components/wheel-storage-state-icon/wheel-storage-state-icon";
import WheelStorageTypeIcon from "../../components/wheel-storage-type-icon/wheel-storage-type-icon";
import BookingStateSelection from "../../components/booking-state-selection/booking-state-selection";
import BookingColorSelection from "../../components/booking-color-selection/booking-color-selection";
import BookingProcessorSelection from "../../components/booking-processor-selection/booking-processor-selection";

export default Angular.module('booking-details',
    [
        Bookings.name,
        Vehicles.name,
        VehicleCheckIcon.name,
        WheelStorageActiveIcon.name,
        WheelStorageStateIcon.name,
        WheelStorageTypeIcon.name,
        BookingStateSelection.name,
        BookingColorSelection.name,
        BookingProcessorSelection.name
    ])
    .component('bookingDetails', {
        template: Template,
        controller: Controller,
        bindings: {
            booking: '<',
            showCustomer: '<',
            showVehicle: '<',
            showVehicleChecks: '<',
            showWheelStorage: '<',
            saveBookingOnUpdate: '<',
            onBookingUpdated: '&'
        }
    })



// WEBPACK FOOTER //
// ./src/modules/main/components/booking-details/booking-details.js